import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { CardEncoderSettingService } from 'src/app/services/card-encoder-setting-service/card-encoder-setting.service';
import { DictionariesService } from 'src/app/services/dictionaries/dictionaries.service';
import { EditDataServiceService } from 'src/app/services/editDataService/edit-data-service.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { UtilitiesService } from 'src/app/services/utilities-service/utilities.service';
import { DictionaryModel } from 'src/app/shared/models/DictionaryModel.model';
import { PublicCardEncoderSettingModel } from 'src/app/shared/models/public-card-encoder-setting-model';
import { CardEncodeType } from 'src/app/shared/models/Utilities/card-encode-type';
import * as _ from "underscore";

@Component({
  selector: 'app-card-encoder-form',
  templateUrl: './card-encoder-form.component.html',
  styleUrls: ['./card-encoder-form.component.scss']
})
export class CardEncoderFormComponent implements OnInit, OnDestroy  {
  constructor(private cardEncoderSettingService: CardEncoderSettingService,
    private loadingService: LoadingService, private editDataServiceService: EditDataServiceService, private router: Router, private utilitiesService: UtilitiesService,
    private snackBar: MatSnackBar, private dictionariesService: DictionariesService) { }

  cardEncoderSetting: PublicCardEncoderSettingModel = {
    id: 0,
    cardEncodeSettings: {
      integratorApiUrl: null,
      cardEncodeType: CardEncodeType.None,
      subcompanyId: 0,
      cardEncoderAuthToken: null,
      cardEncoderUrl: null,
      integratorApiLicenseKeyValidator: null
    },
    cardEncodeType: CardEncodeType.None
  };
  enableSave: boolean;
  cardEncodeTypes = this.getEnumOptions(CardEncodeType);
  subcompanies: DictionaryModel[];
  arrayOfRequests: any[] = [];

  getEnumOptions(enumObj: any) {
    return Object.keys(enumObj)
      .filter(key => !isNaN(Number(enumObj[key])))
      .map(key => ({ value: enumObj[key], name: key }));
  }

  ngOnInit(): void {
    const $this = this;
    $this.loadingService.toggle("");

    $this.arrayOfRequests.push($this.dictionariesService.GetSubcompanyDictionary());

    if ($this.editDataServiceService.cardEncoderSettingIdToEdit != 0) {
      $this.arrayOfRequests.push($this.cardEncoderSettingService.GetCardEncoderSettingById($this.editDataServiceService.cardEncoderSettingIdToEdit));
      $this.editDataServiceService.cardEncoderSettingIdToEdit = 0;
    }

    if ($this.arrayOfRequests.length == 0) {
      $this.loadingService.toggle("");
    }
    forkJoin($this.arrayOfRequests)
      .subscribe(subscriberArray => {

        for (let i = 0; i < subscriberArray.length; i++) {
          const resp = subscriberArray[i];

          switch (i) {
            case 0:
              $this.subcompanies = resp as DictionaryModel[];
              break;
            case 1:
              $this.cardEncoderSetting = resp;
              $this.checkFields();
              break;
          }
        }
        $this.loadingService.toggle("");
      });
  }

  goBack() {
    const $this = this;
    $this.router.navigate(["backoffice/card-encoders"]);
  }

  checkFields() {
    const $this = this;
    const objKeys = _.keys($this.cardEncoderSetting.cardEncodeSettings);
    const notRequiredFields = ['id', 'cardEncodeType', 'integratorToken'];
    const requiredNumber = [];
    for (let index = 0; index < objKeys.length; index++) {
      const key = objKeys[index];

      if (!notRequiredFields.includes(key)) {
        if ($this.utilitiesService.isNullOrEmpty($this.cardEncoderSetting.cardEncodeSettings[key]) && !requiredNumber.includes(key)) {
          $this.enableSave = false;
          return false;
        } else {
          if (requiredNumber.includes(key) && $this.cardEncoderSetting.cardEncodeSettings[key] == 0) {
            $this.enableSave = false;
            return false;
          } else {
            $this.enableSave = true;
          }
        }
      }
    }
  }

  saveData() {
    const $this = this;
    $this.loadingService.toggle("");

    $this.cardEncoderSetting.cardEncodeType = $this.cardEncoderSetting.cardEncodeSettings.cardEncodeType;

    $this.cardEncoderSettingService.SaveOrUpdateCardEncoderSetting($this.cardEncoderSetting).subscribe((resp) => {
      $this.cardEncoderSetting.id = resp.id;
      $this.loadingService.toggle("");
      $this.router.navigate(["backoffice/card-encoders"]);
    });
  }

  ngOnDestroy(): void {
    const $this = this;
  }

}
